import { useEffect } from 'react';
import { useGameStore } from '@/store/gameStore';

/** Syncs OS reduced-motion preference to the store on mount */
export function useReducedMotionSync(): void {
  const setReducedMotion = useGameStore(s => s.setReducedMotion);

  useEffect(() => {
    const mq = window.matchMedia?.('(prefers-reduced-motion: reduce)');
    if (!mq) return;

    const handler = (e: MediaQueryListEvent) => {
      setReducedMotion(e.matches);
    };

    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [setReducedMotion]);
}
